import EditConsultingCompanyContainer from "./EditConsultingCompanyContainer";
export default EditConsultingCompanyContainer;
